<template>
    <common-page flex-column card-content>
        <query-view v-if="code" v-bind="$attrs"
                    :config-code="code">
        </query-view>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";

export default {
    name: "QueryViewPage",
    components: {QueryView, CommonPage},
    data() {
        return {
            code: null
        }
    },
    mounted() {
        this.code = this.$route.params.code;
    }
}
</script>

<style scoped>

</style>
